export const createGoToHome = Odigeo => () => Odigeo.Utils.goToApplicationHome();